import { Component } from '@opten/compiler/metadata/component';

declare const grecaptcha: any;

@Component({ className: 'g-recaptcha' })
export class ReCaptchaComponent {
	constructor(private element: HTMLElement) {
		grecaptcha.ready(() => {
			grecaptcha.render(this.element);
		});
	}
}
